export enum PremiumShippingTypeNames {
  STANDARD = 'Standard',
  TWO_DAY = '2 Day',
  OVERNIGHT = 'Overnight',
}
